import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"connect-row\">\n  <div class=\"row\">\n    <div class=\"calendarIcon\">\n      <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"calendarIconUrl") : stack1), depth0))
    + "\" alt=\"\">\n    </div>\n    <div class=\"column\">\n      <h3>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"connectText") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\n      <div class=\"spa-btn-group center\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"connectWithLink") : stack1), depth0)) != null ? stack1 : "")
    + "\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/connect-with-cc-module",
  "version": "1.0.1",
  "id": "connectWithCcModule",
  "containerID": "creditCardsConnectWithCcModule",
  "moduleName": "credit-cards-connect-with-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "connect-with-cc-module",
  "data": {
    "init": "connectWithCcModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

// this file was created by default via Transmogrify

/**
 * Creates a ConnectWithCcModule class.
 * @returns {Object} ConnectWithCcModule class.
 */
class connectWithCcModule extends Module {
  /**
   * Creates a ConnectWithCcModule class.
   * @param {Object} options options.
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: connectWithCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { connectWithCcModule as default, moduleConfig };
